import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";

export function useUserFeedbackPromptingStatus(userId?: string) {
  const { appId, envId } = useEnvironment();
  return useQuery({
    queryKey: ["apps", appId, "environments", envId, "users", userId, "status"],

    queryFn: async () => {
      if (!appId || !userId) {
        return Promise.resolve("unspecified");
      }

      const res = await api.get<"/apps/:appId/users/:userId/status">(
        `/apps/${appId}/users/${userId}/status`,
        { params: { envId: envId! } },
      );
      return res.data.status;
    },

    enabled: !!appId && !!envId && !!userId,
  });
}
